import { render } from "./soundSettingView.vue?vue&type=template&id=666fa78c&scoped=true&ts=true"
import script from "./soundSettingView.vue?vue&type=script&lang=ts"
export * from "./soundSettingView.vue?vue&type=script&lang=ts"

import "./soundSettingView.vue?vue&type=style&index=0&id=666fa78c&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-666fa78c"]])

export default __exports__